import {Component, Input, OnChanges, OnInit, signal} from '@angular/core';
import {Settings} from '../settings.class';
import {LocalStorage} from '../storage.class';
import {SafeBgUrlPipe} from "../pipes/safe-bg-url.pipe";
import {SafeSrcPipe} from "../pipes/safe-src.pipe";

@Component({
    selector: 'app-codalt-image',
    templateUrl: './codalt-image.component.html',
    styleUrls: ['./codalt-image.component.scss'],
    imports: [
        SafeBgUrlPipe,
        SafeSrcPipe,
    ]
})
export class CodaltImageComponent implements OnInit, OnChanges {

    readonly image = signal<string>('');
    @Input() thumb: string;
    @Input() icon: string;
    @Input() iconBackground: string;
    @Input() private fullUrl: string;
    @Input() private path: string;
    @Input() private secureType = 'article';

    constructor() {
    }

    ngOnInit() {
        this.setImage();
    }

    setImage() {
        if (this.fullUrl) {
            this.image.set(this.fullUrl);
        } else if (this.path && this.path.substr(-4) !== 'null') {
            this.image.set(Settings.API_ENDPOINT +
                'file/thumb?secure=' + this.secureType +
                '&path=/' + this.path +
                '&access_token=' + LocalStorage.getUserToken());
        }
    }

    ngOnChanges() {
        this.setImage();
    }
}
